import type { ReactNode } from "react";
import type { PaneKey } from "./nav.model";

/**
 * The sidebar icons, lifted from the design prototype's nav markup
 * (design/account/index.html). They share one 24x24 stroke geometry, so only
 * the paths differ.
 */
const Glyph = ({ children }: { children: ReactNode }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const NAV_ICONS: Record<PaneKey, ReactNode> = {
  dash: (
    <Glyph>
      <path d="M4 10.4 12 4l8 6.4V19a1 1 0 0 1-1 1h-4v-5H9v5H5a1 1 0 0 1-1-1z" />
    </Glyph>
  ),
  rates: (
    <Glyph>
      <ellipse cx="12" cy="6.5" rx="6.5" ry="2.8" />
      <path d="M5.5 6.5v11c0 1.5 2.9 2.8 6.5 2.8s6.5-1.3 6.5-2.8v-11" />
      <path d="M5.5 12c0 1.5 2.9 2.8 6.5 2.8s6.5-1.3 6.5-2.8" />
    </Glyph>
  ),
  shipments: (
    <Glyph>
      <path d="M3 7.5h10v8H3z" />
      <path d="M13 10.5h3.6l2.9 3v2H13z" />
      <circle cx="7" cy="17.8" r="1.8" />
      <circle cx="16.5" cy="17.8" r="1.8" />
    </Glyph>
  ),
  billing: (
    <Glyph>
      <path d="M12 3.2 20 7.1 12 11 4 7.1z" />
      <path d="M20 12 12 15.9 4 12" />
      <path d="M20 16.9 12 20.8 4 16.9" />
    </Glyph>
  ),
  store: (
    <Glyph>
      <path d="M4 8.5h16l-1.2 10.2a1 1 0 0 1-1 .8H6.2a1 1 0 0 1-1-.8z" />
      <path d="M8.8 8.5V6.8a3.2 3.2 0 0 1 6.4 0v1.7" />
    </Glyph>
  ),
  myqubics: (
    <Glyph>
      <path d="M12 3.6 20 7.8v8.4L12 20.4 4 16.2V7.8z" />
      <path d="M4 7.8 12 12l8-4.2M12 12v8.4" />
    </Glyph>
  ),
  apikeys: (
    <Glyph>
      <circle cx="8.5" cy="12" r="3.5" />
      <path d="M12 12h8M17 12v3.2" />
    </Glyph>
  ),
  settings: (
    <Glyph>
      <circle cx="12" cy="12" r="3.4" />
      <path d="M9.37 3.39 14.63 3.39 14.12 5.85 16.26 7.09 18.14 5.42 20.77 9.98 18.38 10.76 18.38 13.24 20.77 14.02 18.14 18.58 16.26 16.91 14.12 18.15 14.63 20.61 9.37 20.61 9.88 18.15 7.74 16.91 5.86 18.58 3.23 14.02 5.62 13.24 5.62 10.76 3.23 9.98 5.86 5.42 7.74 7.09 9.88 5.85 Z" />
    </Glyph>
  ),
};

/** The fold chevron on a group heading. */
export const FoldChevron = () => (
  <svg
    className="pc-nav__ch"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 6.5 8 10.5 12 6.5" />
  </svg>
);

export const BurgerIcon = () => (
  <Glyph>
    <path d="M4.6 7.2h14.8M4.6 12h14.8M4.6 16.8h14.8" />
  </Glyph>
);

export const BackIcon = () => (
  <Glyph>
    <path d="M14.5 6 8.5 12l6 6" />
  </Glyph>
);

export const DrawerCloseIcon = () => (
  <Glyph>
    <path d="M6.4 6.4l11.2 11.2M17.6 6.4 6.4 17.6" />
  </Glyph>
);
